import { CollapsibleItem } from '@addins/core/singlecallcard';
import { CallCard } from '@models/imported/SagaSchema/CallCard';

export abstract class ParticularsCollapsibleItem extends CollapsibleItem {
  abstract updateVisibility(callCard: CallCard): void;
}
